import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import type { ScanUploadItem, UploadScansResponse } from '@/shared/types/domain';

export const scansApi = {
  upload: (scans: ScanUploadItem[]) =>
    httpClient.post<UploadScansResponse>(endpoints.scans.upload, { scans })
};
